'use client';

import type { MouseEventHandler, ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';

type ChatBubbleProps = {
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  interactive?: boolean;
};

export function ChatBubble({ children, onClick, interactive }: ChatBubbleProps) {
  return (
    <Box
      width="100%"
      alignSelf="stretch"
      paddingInline="10px"
      paddingBlock="8px"
      backgroundColor="neutral.a4"
      borderRadius="md"
      color="fg.muted"
      cursor={interactive ? 'text' : undefined}
      onClick={onClick}
    >
      {children}
    </Box>
  );
}
